import { FC } from 'react';
import classNames from 'classnames';
import { Icon } from '@lambdacurry/component-library';
import { Allergen, DietType } from 'lib/home/generated/types/api';
import { mealPreferenceIconMap, mealPreferenceLabelMap } from '../../../util/helpers/mealPreferences';

export interface MealPreferenceIconLabelProps {
  className?: string;
  preference: Allergen | DietType;
}

export const MealPreferenceIconLabel: FC<MealPreferenceIconLabelProps> = ({ className, preference }) => (
  <div className={classNames(`flex items-center`, className)}>
    <Icon className="mr-2" name={mealPreferenceIconMap[preference]} />
    <p className="h-5 m-0">{mealPreferenceLabelMap[preference]}</p>
  </div>
);
